<template>
	<div>
		<el-dialog
			class="modal-login modal-action"
			:visible.sync="dialogVisible"
			:image-none="true"
			@close="$emit('close')"
		>
			<div slot="title" class="el-dialog__title">
				<span class="img-check">
					<img src="/static/img/icons/check.svg" alt="">
				</span>
				<span>Tu producto se agregó al carrito con éxito</span>
			</div>
			<div class="container-body">
				<div class="image-container">
					<img :src="product.imgPresentation" alt="" height="90%" width="80%">
				</div>
				<div class="content-body">
					<p class="description">{{ product.description }}</p>
					<p
						class="price-discount"
						:style="`color:${globalColors.primary}`"
					>
						{{ currency }}{{ productPriceDiscount }}
					</p>
					<p class="price">
						{{ currency }}{{ productPrice }}
					</p>
				</div>
			</div>
			<div class="container-buttons">
				<button
					class="btn btn-orange"
					@click="$emit('go-to')"
					:style="`background-color:${globalColors.primary}`"
				>
					IR A CARRITO
				</button>
				<button
					class="btn btn-underline"
					@click="$emit('close')"
					:style="`color:${globalColors.titulo}`"
				>
					Seguir comprando
				</button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	function dialog(val) {
		this.dialogVisible = val;
	}

	function productWatcher(value) {
		if (value) {
			const { price, priceDiscount } = value;
			this.productPrice = price && price.toFixed(2);
			this.productPriceDiscount = priceDiscount && priceDiscount.toFixed(2);
		}
	}

	function data() {
		return {
			dialogVisible: false,
			productPrice: 0,
			productPriceDiscount: 0,
		};
	}

	export default {
		name: 'modal-action',
		data,
		props: {
			currency: String,
			dialog: {
				default: false,
				type: Boolean,
			},
			product: {
				default: () => {},
				type: Object,
			},
		},
		watch: {
			dialog,
			product: {
				deep: true,
				handler: productWatcher,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.container-body {
		display: flex;
	}

	.image-container {
		box-shadow: 0px 2px 4px 0px rgba(175, 175, 175, .5);
		display: inline-block;
		height: 11rem;
		padding: 0.6rem 0rem;
		text-align: center;
		width: 11rem;

		@media (min-width: 768px) {
			height: 126px;
			width: 126px;
		}
	}

	.content-body {
		display: inline-block;
		padding-left: 7px;

		@media (min-width: 768px) {
			padding-left: 36px;
		}
	}

	.description {
		font-family: font(avenirDemi);
		font-size: size(small);
		margin: 0px 0px 14px;

		@media (min-width: 768px) {
			font-size: size(maxmedium);
			margin: 14px 0px;
		}
	}

	.price-discount {
		font-family: font(avenirBold);
		font-size: size(minlarge);
		margin: 0px;
	}

	.price {
		color: color(text-grey);
		font-family: font(avenir);
		font-size: size(maxmedium);
		margin: 0px;
	}

	.container-buttons {
		padding-top: 5px;
		text-align: center;
	}

	.btn {
		border: none;
		color: color(white);
		font-family: font(avenirDemi);
		font-size: size(msmall);
		height: 41px;
		outline: none;
		padding-top: 5px;
		width: 166px;

		&:last-child {
			margin-right: 0;
		}

		@media (min-width: 768px) {
			font-size: size(maxmedium);
			height: 50px;
			padding: 5px 25px 0px;
			width: auto;
		}
	}

	.btn-orange {
		margin-top: 30px;

		@media (min-width: 768px) {
			margin-top: 0px;
		}
	}

	.btn-underline {
		background-color: transparent;
		margin-top: 10px;
		text-decoration: underline;

		@media (min-width: 768px) {
			margin-top: 0px;
		}
	}

	.img-check {
		border: 3px solid color(white);
		border-radius: 100%;
		display: inline-block;
		height: 21px;
		line-height: 16px;
		margin-right: 10px;
		text-align: center;
		width: 21px;

		@media (min-width: 768px) {
			height: 23px;
			line-height: 18px;
			margin-right: 22px;
			width: 23px;
		}

		img {
			height: 9px;

			@media (min-width: 768px) {
				height: 10px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// modal-action.vue?007ed124